var Toggle_module_default = {
	container: "_container_udcm8_10",
	input: "_input_udcm8_24",
	ui: "_ui_udcm8_34"
};
//#endregion
export { Toggle_module_default as default };

//# sourceMappingURL=Toggle.module.js.map